var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M128 234.773C186.91 234.773 234.667 187.017 234.667 128.107C234.667 69.1963 186.91 21.44 128 21.44C69.0896 21.44 21.3333 69.1963 21.3333 128.107C21.3333 187.017 69.0896 234.773 128 234.773Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 74.0267C105.92 74.0267 88 91.9467 88 114.027C88 135.68 104.96 153.28 127.467 153.92C127.787 153.92 128.213 153.92 128.427 153.92C128.64 153.92 128.96 153.92 129.173 153.92C129.28 153.92 129.387 153.92 129.387 153.92C150.933 153.173 167.893 135.68 168 114.027C168 91.9467 150.08 74.0267 128 74.0267Z",
    fill: "#D7D7D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.32 206.507C181.333 224 155.947 234.773 128 234.773C100.053 234.773 74.6667 224 55.68 206.507C58.24 196.8 65.1733 187.947 75.3067 181.12C104.427 161.707 151.787 161.707 180.693 181.12C190.933 187.947 197.76 196.8 200.32 206.507Z",
    fill: "#D7D7D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.c8988129b436e5aad47326b46fc890d7.svg";
export { ForwardRef as ReactComponent };